module.exports = __webpack_public_path__ + "img/client2.0f880d29.png";